import script from "./ButtonInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonInput.vue?vue&type=script&setup=true&lang=js"

import "./ButtonInput.vue?vue&type=style&index=0&id=141dd576&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-141dd576"]])

export default __exports__